<template>
  <SpaceOpener class="h-full">
    <Notes />
  </SpaceOpener>
</template>

<script>
import SpaceOpener from '../components/space-opener';
import Notes from '../components/notes';

export default {
  name: 'NotesPage',
  props: [],
  components: {
    SpaceOpener,
    Notes,
  },
  data: function () {
    return {
    };
  },
  computed: {
  },
  methods: {
  },
  mounted() {
  },
}

</script>

<style>
#editor {
  border: none;
  box-shadow: none;
}
</style>
